import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconArrowDown({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M.234 2.244a.777.777 0 0 1 1.056-.07l.076.07L4 4.987l2.634-2.743a.777.777 0 0 1 1.056-.07l.076.07c.288.3.31.773.066 1.1l-.066.079-3.2 3.333a.777.777 0 0 1-1.056.07l-.076-.07-3.2-3.333a.858.858 0 0 1 0-1.179z"/>
        </svg>
    );
}

export default IconArrowDown;

